/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:47
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-21 08:53:16
 * @FilePath: \huaxin-project-5\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import mixin from "./util/mixin.js";

import router from "./router";
import "amfe-flexible";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/fonts/font.css";

import "./assets/css/animate.min.css";
import "./assets/css/common.scss"; // 公用样式
import "./assets/css/style1.scss";
import "./assets/css/style.scss";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "./util/rem.js"; //在main.js中引入rem.js

import { getToken } from "@/util/auth";
import waterMark from "./util/waterMark";
import scroll from "vue-seamless-scroll";
import VideoPlayer from "vue-video-player";
Vue.config.productionTip = false;
Vue.prototype.baseUrl = window.baseUrl;
Vue.prototype.webUrl = window.webUrl;
Vue.mixin(mixin);
Vue.use(ElementUI);
Vue.use(scroll);
Vue.use(VideoPlayer);
Vue.directive("watermark", waterMark);
const siteInfo = JSON.parse(localStorage.getItem("siteInfo"));
router.afterEach((to, from) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
  document.title = siteInfo.Title;
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", siteInfo.Keywords);
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", siteInfo.Description);
});
new Vue({
  router,
  store,
  mounted() {
    // setTimeout(() => {
    //   const { title } = this.$route.meta;
    //   document.title = "筑才学院-" + title;
    // }, 500);
  },
  created() {
    const Token = getToken() || null;
    this.$store.state.Token = Token;
  },
  render: (h) => h(App),
}).$mount("#app");
